module.exports = __webpack_public_path__ + "assets/terms/termos-pe.e448ee74.pdf";